import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";

import SmoothScroll from "@/components/site/SmoothScroll";
import ScrollToTop from "@/components/site/ScrollToTop";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingContacts from "@/components/site/FloatingContacts";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Legacy from "@/pages/Legacy";
import Stay from "@/pages/Stay";
import RoomDetail from "@/pages/RoomDetail";
import Pool from "@/pages/Pool";
import Food from "@/pages/Food";
import Campfire from "@/pages/Campfire";
import Games from "@/pages/Games";
import Nearby from "@/pages/Nearby";
import Reviews from "@/pages/Reviews";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/legacy" element={<Legacy />} />
        <Route path="/stay" element={<Stay />} />
        <Route path="/stay/:slug" element={<RoomDetail />} />
        <Route path="/experiences" element={<Navigate to="/experiences/pool" replace />} />
        <Route path="/experiences/pool" element={<Pool />} />
        <Route path="/experiences/food" element={<Food />} />
        <Route path="/experiences/campfire" element={<Campfire />} />
        <Route path="/experiences/games" element={<Games />} />
        <Route path="/experiences/nearby" element={<Nearby />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App grain relative min-h-screen bg-ivory">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Navbar />
          <AnimatedRoutes />
          <Footer />
          <FloatingContacts />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
